// extracted by mini-css-extract-plugin
export var modalOpen = "SearchOverlay-module--modal-open--tIsMW";
export var primary = "#06004d";
export var searchOverlay = "SearchOverlay-module--search-overlay--4smkq";
export var searchOverlayContent = "SearchOverlay-module--search-overlay-content--4Eudi";
export var searchOverlayContentBody = "SearchOverlay-module--search-overlay-content-body--k-R9f";
export var secondary = "#4dafd7";